import Vue from 'vue';
// import Vuex from 'vuex'
import SitecoreVueBridge from '@refapp/sitecore-vue-bridge';

import 'picturefill';
import 'lazysizes';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

// seo-
import Meta from 'vue-meta';
import promise from 'es6-promise';
import VueCookies from 'vue-cookies';
import VueLazyload from 'vue-lazyload';
import ScreenSizeHandler from '../../utilities/screenSizeHandler';
import loadUIModules from '../../utilities/loadUIModules';

import store from '../../store';

import ProductDescription from '../../components/product-description/product-description.vue';
import ProductPurchase from '../../components/product-purchase/product-purchase.vue';
import ProductCart from '../../components/product-cart/product-cart.vue';
import ProductCartAccount from '../../components/product-cart-account/product-cart-account.vue';
import pdpEcommerce from '../../components/product-images/pdp-ecommerce.vue';
import ProductImages from '../../components/product-images/product-images.vue';
import ProductDiagnostic from '../../components/product-diagnostic/product-diagnostic.vue';
import DiagnosticModal from '../../components/product-diagnostic/diagnostic-modal.vue';
import RecommendedProductList from '../../components/product-diagnostic/recommended-product-list.vue';
import AugmentProductCarousel from '../../components/product-diagnostic/augment-product-carousel.vue';
import CarouselInstaller from '../../components/carousel';
import AnimatedLine from '../../components/animated-line/animated-line.vue';
import StickyElement from '../../components/stickyelement/stickyelement.vue';
import StickyBar from '../../components/sticky-bar/sticky-bar.vue';
import ProductListInstaller from '../../components/product-list';
import ArticleListInstaller from '../../components/article-list';
import LoadingOverlay from '../../components/loading-overlay/loading-overlay.vue';
import NewsletterSubscriptionForm from '../../components/newsletter-subscription-form/newsletter-subscription-form.vue';
import Popin from '../../components/popin/popin.vue';
import FindASalon from '../../components/find-a-salon/find-a-salon.vue';
import InputHandler from '../../utilities/inputHandler/inputHandler';
import ProductImpression from '../../directives/product-impression/product-impression';
import StickyFilters from '../../directives/sticky-filters/sticky-filters';
import CookieBanner from '../../components/cookie-banner/cookie-banner.vue';
import InlineScript from '../../components/inline-script/inline-script.vue';
import StarRatings from '../../components/star-ratings/star-ratings.vue';
import RfpRareStarRatingsNew from '../../components/star-ratings/rfp-rare-star-ratings.vue';
import MctbCarousel from '../../components/multiple-clicktobuy/mctb-slider/mctb-carousel.vue';
import HomepageCarouselNew from '../../components/homepage-carousel';
import MctbSlide from '../../components/multiple-clicktobuy/mctb-slider/mctb-slide.vue';
import searcHeader from '../../components/searchbar/search-header.vue';
import searchFilter from '../../components/searchbar/searchfilter.vue';
// import Instagram from '../../components/instagram/instagram.vue'
import Collapse from '../../components/collapse/collapse.vue';
import Timer from '../../components/timer/timer.vue';
import Modal from '../../components/modal/modal.vue';
import ProductCarousel from '../../components/product-carousel/product-carousel.vue';
import BeforeAfter from '../../components/before-after/before-after.vue';
import BeforeAfterBlock from '../../components/before-after/before-after-block.vue';
import BeforeAfterAugmented from '../../components/before-after/before-after-augmented.vue';
import BeforeAfterBlockAugmented from '../../components/before-after/before-after-block-augmented.vue';
import RedirectionPopin from '../../components/redirection-popin/redirection-popin.vue';
import SummaryMenu from '../../components/jump-function/summary-menu.vue';
import HeaderBanner from '../../components/article-revamp/header-banner.vue';
import ArticleTopicBlock from '../../components/article-revamp/article-topic-block.vue';
import DontMissBlock from '../../components/article-revamp/dont-miss-block.vue';
import TwoImageBlock from '../../components/two-image-block/two-image-block.vue';
import ArticleHighlightSlider from '../../components/article-revamp/article-highlight-slider.vue';
import ArticleSubtopicBlock from '../../components/article-revamp/article-subtopic-block.vue';
import ArticlesBlock from '../../components/article-revamp/articles-block.vue';
import HowToUseBlock from '../../components/augmented/how-to-use-block.vue';
import DiagnosisBlock from '../../components/augmented/diagnosis-block.vue';
import AugmentedBlock from '../../components/augmented/augmented-block.vue';
import AugmentedProductList from '../../components/augmented/augmented-product-list.vue';
import AugmentedModalData from '../../components/augmented/augmented-modal-data.vue';
import AugmentedRoundedImage from '../../components/augmented/augmented-rounded-image.vue';
import AugmentedSlider from '../../components/augmented/augmented-slider.vue';
import AugmentedFaq from '../../components/augmented/augmented-faq.vue';
import Protips from '../../components/augmented/protips.vue';
import IntroductionBlock from '../../components/augmented/introduction-block.vue';
import WhatsInside from '../../components/augmented/whats-inside.vue';
import HowToDiagnose from '../../components/augmented/how-to-diagnose.vue';
import RangeBlock from '../../components/augmented/range-block.vue';
import CurlInSalon from '../../components/augmented/curl-in-salon.vue';
import HowItsMade from '../../components/augmented/how-its-made.vue';
import DiagnosisHeaderBanner from '../../components/diagnosis-banner/diagnosis-header-banner.vue';
import RoutineAddtocartPopinButton from '../../components/routine-multi/routine-addtocart-popin-button.vue';
import EditorialRichText from '../../components/editorial-rich-text/editorial-rich-text.vue';
import BannerMixedContentSliders from '../../components/banner-mixed-content-sliders/banner-mixed-content-sliders.vue';
import BannerCarousel from '../../components/banner-carousel/banner-carousel.vue';
import ProductSlider from '../../components/product-slider/product-slider.vue';
import ProductCardCarousel from '../../components/product-card-carousel/product-card-carousel.vue';
import ImmersiveCarousel from '../../components/immersive-carousel/immersive-carousel.vue';
import SkinDiagInvite from '../../components/skin-diag-invite/skin-diag-invite.vue';
import QuickLinksFolder from '../../components/quick-links-folder/quick-links-folder.vue';
import fullWidthSlider from '../../components/full-width-slider/full-width-slider.vue';
import carouselIndicator from '../../components/full-width-slider/carousel-indicator.vue';
import ContentVideoSilder from '../../components/content-video-slider/content-video-slider.vue';
import VideoPopup from '../../components/video-popup/video-popup.vue';
import addtocart from '../../components/addtocart/addtocart.vue';
import FooterForm from '../../components/footer-form/footer-form.vue';

import '../../common.js';

import RoutineMulti from '../../components/routine-multi/routine-multi.vue';
import Tooltip from '../../components/tooltip/tooltip.vue';
import VueScrollTo from 'vue-scrollto';
import VueAnimateOnScroll from 'vue-animate-onscroll';
import CommerceConnector from '../../components/commerce-connector/commerce-connector.vue';
import QualifioPopup from '../../components/qualifio-popup/qualifio-popup.vue';

import {
  ellipsis,
  clickextension,
  tutorialHelper,
  loadscript,
  jumpToContent,
  backgroundDirective,
  nativevideoLoad,
  lazyscript,
  clickOutside,
} from '../../directives';

import '../../features/editorial-rich-text/entry.js';
import '../../features/media/entry.js';
import '../../features/navigation/entry.js';
import '../../features/photo-album/entry.js';
import '../../features/tabs/entry.js';
import '../../features/routine/entry.js';
import '../../features/tagging/entry.js';

// polyfill promises
promise.polyfill();

// bind to lazesizes image ready event
window.eventBus = new Vue();
const eventBus = window.eventBus;
document.addEventListener('lazybeforeunveil', (e) => {
  if (eventBus) {
    eventBus.$emit('images.lazybeforeunveil', e);
  }
});

/**
 * Initiate ScreenSizeHandler helper class.
 * Will use the eventBus to emit mediaquery changes based on matchMedia listeners
 * Also has functions to ask for the current media query or to get a matchMedia object by screensize
 * Attached to window so it can be referenced on feature and project level
 */
if (document.getElementById('lf_header') === null) {
  const mqs = JSON.parse(
    window
      .getComputedStyle(document.querySelector('#screensize-handler-trigger'), ':before')
      .getPropertyValue('content')
      .replace(/\\/g, '')
      .slice(1, -1),
  );
  window.ScreenSizeHandler = new ScreenSizeHandler(mqs);
}

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = true;
window.lazySizesConfig.expand = 10;
window.lazySizesConfig.expFactor = 1.5;
window.lazySizesConfig.loadMode = 0;

Vue.use(CarouselInstaller);
Vue.use(ProductListInstaller);
Vue.use(ArticleListInstaller);
Vue.use(HomepageCarouselNew);
Vue.use(ProductImpression);
Vue.use(StickyFilters);
Vue.use(VueAnimateOnScroll);
Vue.use(VueCookies);
Vue.use(VueLazyload);

Vue.use(VueScrollTo);
Vue.use(Meta);

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
// Vue.use(Vuex)

Vue.component(LoadingOverlay.name, LoadingOverlay);
Vue.component(ProductDescription.name, ProductDescription);
Vue.component(ProductPurchase.name, ProductPurchase);
Vue.component(ProductCart.name, ProductCart);
Vue.component(ProductCartAccount.name, ProductCartAccount);
Vue.component(pdpEcommerce.name, pdpEcommerce);
Vue.component(ProductImages.name, ProductImages);
Vue.component(AnimatedLine.name, AnimatedLine);
Vue.component(StickyElement.name, StickyElement);
Vue.component(NewsletterSubscriptionForm.name, NewsletterSubscriptionForm);
Vue.component(Popin.name, Popin);
Vue.component(FindASalon.name, FindASalon);
Vue.component(CookieBanner.name, CookieBanner);
Vue.component(InlineScript.name, InlineScript);
Vue.component(StarRatings.name, StarRatings);
Vue.component(RfpRareStarRatingsNew.name, RfpRareStarRatingsNew);
Vue.component(MctbCarousel.name, MctbCarousel);
Vue.component(MctbSlide.name, MctbSlide);
Vue.component(ProductCarousel.name, ProductCarousel);
Vue.component(ProductDiagnostic.name, ProductDiagnostic);
Vue.component(DiagnosticModal.name, DiagnosticModal);
Vue.component(RecommendedProductList.name, RecommendedProductList);
Vue.component(RedirectionPopin.name, RedirectionPopin);
Vue.component(BeforeAfter.name, BeforeAfter);
Vue.component(BeforeAfterBlock.name, BeforeAfterBlock);
Vue.component(BeforeAfterAugmented.name, BeforeAfterAugmented);
Vue.component(BeforeAfterBlockAugmented.name, BeforeAfterBlockAugmented);
Vue.component(SummaryMenu.name, SummaryMenu);
Vue.component(HeaderBanner.name, HeaderBanner);
Vue.component(ArticleTopicBlock.name, ArticleTopicBlock);
Vue.component(DontMissBlock.name, DontMissBlock);
Vue.component(TwoImageBlock.name, TwoImageBlock);
Vue.component(ArticleHighlightSlider.name, ArticleHighlightSlider);
Vue.component(HowToUseBlock.name, HowToUseBlock);
Vue.component(Protips.name, Protips);
Vue.component(DiagnosisBlock.name, DiagnosisBlock);
Vue.component(AugmentedBlock.name, AugmentedBlock);
Vue.component(AugmentedProductList.name, AugmentedProductList);
Vue.component(AugmentedModalData.name, AugmentedModalData);
Vue.component(AugmentedRoundedImage.name, AugmentedRoundedImage);
Vue.component(AugmentedSlider.name, AugmentedSlider);
Vue.component(AugmentedFaq.name, AugmentedFaq);
Vue.component(ArticleSubtopicBlock.name, ArticleSubtopicBlock);
Vue.component(ArticlesBlock.name, ArticlesBlock);
Vue.component(IntroductionBlock.name, IntroductionBlock);
Vue.component(WhatsInside.name, WhatsInside);
Vue.component(HowToDiagnose.name, HowToDiagnose);
Vue.component(RangeBlock.name, RangeBlock);
Vue.component(CurlInSalon.name, CurlInSalon);
Vue.component(HowItsMade.name, HowItsMade);
Vue.component(AugmentProductCarousel.name, AugmentProductCarousel);
// Vue.component(Instagram.name, Instagram)
Vue.component(Collapse.name, Collapse);
Vue.component(DiagnosisHeaderBanner.name, DiagnosisHeaderBanner);
Vue.component(fullWidthSlider.name, fullWidthSlider);
Vue.component(carouselIndicator.name, carouselIndicator);

Vue.component(RoutineMulti.name, RoutineMulti);
Vue.component(RoutineAddtocartPopinButton.name, RoutineAddtocartPopinButton);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Timer.name, Timer);
Vue.component(searcHeader.name, searcHeader);
Vue.component(searchFilter.name, searchFilter);
Vue.component(Modal.name, Modal);
Vue.component(EditorialRichText.name, EditorialRichText);
Vue.component(ProductSlider.name, ProductSlider);

Vue.component(ProductCardCarousel.name, ProductCardCarousel);
Vue.component(ImmersiveCarousel.name, ImmersiveCarousel);
Vue.component(BannerMixedContentSliders.name, BannerMixedContentSliders);
Vue.component(BannerCarousel.name, BannerCarousel);
Vue.component(SkinDiagInvite.name, SkinDiagInvite);
Vue.component(QuickLinksFolder.name, QuickLinksFolder);
Vue.component(StickyBar.name, StickyBar);
Vue.component(QualifioPopup.name, QualifioPopup);
Vue.component(ContentVideoSilder.name, ContentVideoSilder);
Vue.component(VideoPopup.name, VideoPopup);
Vue.component(addtocart.name, addtocart);
Vue.component(FooterForm.name, FooterForm);

Vue.directive('ellipsis', ellipsis);
Vue.directive('clickextension', clickextension);
Vue.directive('tutorialHelper', tutorialHelper);
Vue.directive('loadscript', loadscript);
Vue.directive('jumpToContent', jumpToContent);
Vue.directive('background', backgroundDirective);
Vue.directive('nativevideoLoad', nativevideoLoad);
Vue.directive('lazyscript', lazyscript);
Vue.directive('clickOutside', clickOutside);

Vue.component(CommerceConnector.name, CommerceConnector);

/**
 * Initiate InputHandler helper class.
 * InputHandler listens to keyboard and mouse events on the document.
 * It adds a classname to the body while the user is using keyboard navigation.
 * It removes the keyboard using classname when the user uses the mouse again.
 * Attached to window so it can be referenced on feature and project level
 */
window.InputHandler = new InputHandler();

await loadUIModules(
  [
    '@refapp/ui-store-locator',
    '@refapp/ui-click-to-buy',
    '@refapp/ui-ratings-reviews',
    '@refapp/ui-user-redirect',
    '@refapp/ui-video',
  ],
  Vue,
);

const app = new Vue({
  store,
});

const mountSelector = document.getElementById('lf_header') ? '#lf_header' : '#main-container';

SitecoreVueBridge.initializeVueApp(app.$mount.bind(app, mountSelector));
